export const BuildInfo = {timestamp:1788883928000}
